import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Table,
  Container,
  DropdownToggle,
  DropdownMenu, DropdownItem, UncontrolledDropdown
} from "reactstrap";
import MetaTags from "react-meta-tags";

// datatable related plugins
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone
} from "react-bootstrap-table2-paginator";

import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";

//Import Breadcrumb
import Breadcrumbs from "../../components/common/Breadcrumb";
import "../../../src/assets/scss/custom/plugins/_datatables.scss";
import { ApiCore } from "../../helpers/api_helper";
import { Loading } from "../../components/common/Loading";
import { AxiosResponse } from "axios";
import XModal from "../../components/common/XModal";
import CreateForm from "../../components/forms/CreateForm";
import { Endpoints } from "../../utils/Endpoints";
import { StudentFields } from "../../fields/StudentFields";
import SearchMarks from "./search";
import BulkUpload from "./upload";
import {toast, ToastContainer} from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import { amountToCurrency, can } from "../../utils/Helpers";
import { useHistory } from "react-router-dom";
import FinanceUpload from "./FinanceUpload";

const Students = () => {

  const [loading, setLoading] = useState<boolean>(true);
  const [students, setStudents] = useState<any>([]);
  const [showStudentDialog, setShowStudentDialog] = useState<boolean>(false);
  const [showStudentBulkDialog, setShowStudentBulkDialog] = useState<boolean>(false);
  const [showFinanceDialog, setShowFinanceDialog] = useState<boolean>(false);
  const [uploadResponseMsg, setUploadResponseMsg] = useState<string>("");
  const history = useHistory();
  const [initialValues, setInitialValues] = useState<any>({
    firstname: "",
    lastname: ""
  });

  const columns = [
    {
      dataField: "firstname",
      text: "Student Name",
      formatter: (cellContent: any, item: any) => <span>{item.firstname} {item.lastname} {item.othername}</span>
    },
    {
      dataField: "form",
      text: "Class",
      formatter: (cellContent: any, item: any) => <span>{item.form} {item.stream}</span>
    },
    {
      dataField: "studentid",
      text: "Student ID"
    },
    {
      dataField: "phone",
      text: "Phone"
    },
    {
      dataField: "studentcategory.name",
      text: "Category"
    },
    {
      dataField: "paymentcode",
      text: "Payment Code"
    },
    {
      text: "Balance",
      dataField: "balance",
      headerAlign: "right",
      align: "right",
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent: any, record: any) => {
        return amountToCurrency(record.balance);
      },
    },
    {
      dataField: "",
      text: "",
      // eslint-disable-next-line react/display-name
      formatter: (cellContent: any, product: any) => <UncontrolledDropdown>
        <DropdownToggle className="card-drop" tag="a">
          <i className="mdi mdi-dots-horizontal font-size-18 text-muted"></i>
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          <DropdownItem to="#" onClick={() => handleOption(product, "edit")}>
            <i className="mdi mdi-pencil font-size-16 text-success me-1"></i> Edit
          </DropdownItem>
          <DropdownItem to="#" onClick={() => handleOption(product, "details")}>
            <i className="mdi mdi-pencil font-size-16 text-success me-1"></i> Details
          </DropdownItem>
        </DropdownMenu>
      </UncontrolledDropdown>
    }
  ];


  const handleOption = (item: any, type: string) => {
    if (type == "edit") {
      setInitialValues(item);
      setShowStudentDialog(true);
    } else if (type == "new") {
      setInitialValues({
        firstname: "",
        lastname: ""
      });
      setShowStudentDialog(true);
    } else if (type == "finance") {
      setShowFinanceDialog(true);
    } else if (type == "bulk") {
      setShowStudentBulkDialog(true);
    } else if (type == "details") {
      history.push("/students/" + item.id);
    } else if (type == "promote") {
      if(window.confirm("This operation can not be reversed. Do you really want to proceed with it?")) {
        handlePromote();
      }
    }
  }
  
  const handleFinanceUpload = (values: any) => {
    const responseType = "json";
    toast.promise(request.createFormData(Endpoints.uploads + "/studentjournals", values, responseType), {
      pending: "Please wait..",
      success: {
        render({data}) {
          let message: any = "";
          return message;
        }
      },
      error: {
        render({data}) {
          return data;
        }
      }
    }).then((response: AxiosResponse) => {
      if (values.file) {
        //Nothing to do here
      } else if(values.excel && values.excel == 1) {
        const type = response.headers['content-type']
        const blob = new Blob([response.data], {type: type})
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = `mustard-${+ new Date()}.xlsx`
        link.click()
      }
    });
  }

  const defaultSorted: any = [
    {
      dataField: "name",
      order: "asc"
    }
  ];

  const pageOptions: any = {
    sizePerPage: 25,
    totalSize: students.length,
    custom: true
  };

  const selectRow: any = {
    mode: "checkbox"
  };

  const request = new ApiCore();

  useEffect(() => {
    searchStudents({})
  }, []);

  const handleUpdate = (item: any) => {
    const items = students.map((i: any) => {
      if (i.id === item.id){
        return {...i, ...item};
      }

      return i;
    })
    setStudents(items);
  };

  const searchStudents = (values: any) => {
    toast.promise(request
    .get(Endpoints.students, { params: values }, values.excel && values.excel == 1 ? "arraybuffer" : "json"), {
      pending: "Please wait..",
      success: {
        render({data}) {
          let message: any = "";
          return message;
        }
      },
      error: {
        render({data}) {
          return data;
        }
      }
    }).then((response: AxiosResponse) => {
      if(values.excel && values.excel == 1) {
        const type = response.headers['content-type']
        const blob = new Blob([response.data], {type: type})
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = `mustard-${+ new Date()}.xlsx`
        link.click()
      } else {
        const { students, totalRecords } = response.data;
        setStudents(students);
        setLoading(false);
      }
    });
  }

  const handleBulkUpload = (values: any) => {
    const responseType = "arraybuffer";
    toast.promise(request.createFormData(Endpoints.students, values, responseType), {
      pending: "Please wait..",
      success: {
        render({data}) {
          let message: any = "";
          return message;
        }
      },
      error: {
        render({data}) {
          return data;
        }
      }
    }).then((response: AxiosResponse) => {
      if (values.file) {
        //Nothing to do here
      } else if(values.excel && values.excel == 1) {
        const type = response.headers['content-type']
        const blob = new Blob([response.data], {type: type})
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = `mustard-${+ new Date()}.xlsx`
        link.click()
      }
    });
  }

  const handlePromote = () => {
    const responseType = "arraybuffer";
    toast.promise(request.get(Endpoints.promoteStudents, {promote: 1}), {
      pending: "Please wait..",
      success: {
        render({data}) {
          return data;
        }
      },
      error: {
        render({data}) {
          return data;
        }
      }
    });
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Students - Treda</title>
        </MetaTags>

        <Container fluid>
          <Breadcrumbs title="Students" breadcrumbItem="List" />

          <XModal title={"Add a student"}
                  width={"lg"}
                  open={showStudentDialog}
                  toggle={() => setShowStudentDialog(!showStudentDialog)}
                  onClose={() => setShowStudentDialog(false)}>

            <CreateForm
              fields={StudentFields}
              initialValues={initialValues}
              submitEndpoint={initialValues.id ? Endpoints.students + "/" + initialValues.id : Endpoints.students}
              submitButtonLabel={initialValues.id ? "Edit Student" : "Add Student"}
              debug={false}
              handleUpdate={handleUpdate}
              onClose={() => setShowStudentDialog(false)} />

          </XModal>

          <XModal title={"Upload students"}
                  width={"lg"}
                  open={showStudentBulkDialog}
                  toggle={() => setShowStudentBulkDialog(!showStudentBulkDialog)}
                  onClose={() => setShowStudentBulkDialog(false)}>

            <BulkUpload handleSubmit={handleBulkUpload} initialValues={{autoid: 0}} />

          </XModal>

          <XModal title={"Upload Financial Records"}
                  width={"lg"}
                  open={showFinanceDialog}
                  toggle={() => setShowFinanceDialog(!showFinanceDialog)}
                  onClose={() => setShowFinanceDialog(false)}>

            <FinanceUpload handleSubmit={handleFinanceUpload} initialValues={{term: "", year: "", invoice: 7, receipt: 42}} message={uploadResponseMsg} />

          </XModal>

          <Row>
            <Col md={12} lg={12} xl={12}>
              <Card>
                <CardHeader className="justify-content-between d-flex align-items-center">
                  <CardTitle className="h4">
                    Students
                  </CardTitle>

                  <UncontrolledDropdown className="mt-4 mt-sm-0">
                    <DropdownToggle tag="a" className="btn btn-light">
                      <i className="fa fa-ellipsis-v"></i>
                    </DropdownToggle>

                    <DropdownMenu className="dropdown-menu-end">
                      {can("manage","School::Student") && (
                        <>
                          <DropdownItem to="#" onClick={() => handleOption(null, "new")}>
                          Add student
                          </DropdownItem>
                          <DropdownItem to="#" onClick={() => handleOption(null, "bulk")}>
                            Upload students
                          </DropdownItem>
                          <DropdownItem to="#" onClick={() => handleOption(null, "promote")}>
                            Promote students
                          </DropdownItem>
                          <DropdownItem to="#" onClick={() => handleOption(null, "finance")}>
                            Upload Financial Records
                          </DropdownItem>  
                        </>
                      )}

                    </DropdownMenu>
                  </UncontrolledDropdown>
                </CardHeader>
                <CardBody>
                  {loading && <Loading label="Loading students. Please wait." />}
                  {!loading &&
                    <PaginationProvider
                      pagination={paginationFactory(pageOptions)}
                    >
                      {({ paginationProps, paginationTableProps }) => (
                        <ToolkitProvider
                          keyField="id"
                          columns={columns}
                          data={students}
                          search
                          bootstrap4
                        >
                          {toolkitProps => (
                            <React.Fragment>
                              <Row className="mb-2">
                                <Col xl="12">
                                  <SearchMarks
                                    handleSearch={(values: any) => {
                                      searchStudents(values);
                                    }}
                                  />
                                </Col>
                                <ToastContainer />
                              </Row>

                              <Row>
                                <Col xl="12">
                                  <div className="table-responsive">
                                  <BootstrapTable
                                    {...toolkitProps.baseProps}
                                    {...paginationTableProps}
                                    defaultSorted={defaultSorted}
                                    classes={
                                      "table align-middle table-nowrap table-hover"
                                    }
                                    bordered={false}
                                    striped={true}
                                  />
                                  </div>
                                </Col>
                              </Row>

                              <Row className="align-items-md-center mt-30">
                                <Col className="inner-custom-pagination d-flex">
                                  <div className="text-md-right ms-auto">
                                    <PaginationListStandalone
                                      {...paginationProps}
                                    />
                                  </div>
                                </Col>
                              </Row>
                            </React.Fragment>
                          )}
                        </ToolkitProvider>
                      )}
                    </PaginationProvider>
                  }

                </CardBody>
              </Card>
            </Col>
          </Row>

        </Container>

      </div>
    </React.Fragment>
  );
};

export default Students;